/* @flow */

import { fetchJson } from 'utils/fetch';

export const YOUTUBE_REGEX: RegExp = /(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\/?\?(?:\S*?&?v=))|youtu\.be\/)([a-zA-Z0-9_-]*)/;
export const THUMBNAIL_THROTTLE_MILLIS = 3000;

export const tryExtractId = value => {
  const match = value.match(YOUTUBE_REGEX);

  if (match && match[1]) {
    return match[1];
  }

  return null;
};

export const idToUrl = id => {
  return id ? `https://www.youtube.com/watch?v=${id}` : '';
};

export const fetchThumbnail = (id: string) =>
  fetchJson(`/youtube/videos/${id}`).then(video => ({
    video,
  }));



// WEBPACK FOOTER //
// ./src/utils/youtube.js